import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntStockOrgIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      {/* Three stacked boxes. Solid blocks with 2px gaps: the slicer renders this
          at 12px, where any interior detail would fill in. */}
      <rect x="5" y="1" width="6" height="6" rx="1" />
      <rect x="0.5" y="9" width="6" height="6" rx="1" />
      <rect x="9.5" y="9" width="6" height="6" rx="1" />
    </SntIcon>
  );
};

export default SntStockOrgIcon;
